import { TestResultParam } from './components/smart/components/item/types';

type StringOrNumber = string | number;
export type TestResultParams = Array<TestResultParam> | null;

export interface IChild {
  id: StringOrNumber;
  name: string;
  surname: string;
  age?: StringOrNumber;
  birthday?: string;
  gender: string;
  photo?: string;
  active: boolean;
  index: number;
  pfdodModule: boolean;
  childEditDelete: (eventName: string) => void;
  childSelected: () => void;
  routeControl: (name: string) => void;
}

export enum ToolTextEnum {
  CONFIRMED = 'Отлично! Данные об обучающемся подтверждены.',
  NO_CONFIRMED = 'Данные о человеке необходимо подтвердить в любом учреждении доп. образования. При себе иметь СНИЛС и ваш паспорт.',
}

export enum ModulesEnum {
  PFDOD = 'pfdod',
  // NOKO = 'noko',
  // MENTORING = 'mentoring',
}



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/types.ts